<template>
  <div class="wrap">


    <Header></Header>
    <slot />

    

  </div>
</template>

<script>
import Header from "../components/Header.vue";
import BarcodeSide from '../components/BarcodeSide.vue';


export default {
  name: "LayoutDefault",
  components: {
    Header,
    BarcodeSide,
  }
};
</script>